<template>
  <div class="bg-navy-950 py-20 px-5 lg:px-8 lg:py-28">
    <div class="mx-auto max-w-7xl">
      <div class="grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.22em] text-sky-300">How it works</p>
          <h2 class="mt-4 text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Simple from first call to final rinse.
          </h2>
          <p class="mt-5 text-lg leading-8 text-sky-200/80">
            No pushy sales, no vague pricing. You get a clear quote up front and a tidy site when we leave.
          </p>

          <div class="mt-10 flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
            <a href="tel:+447534490921" class="btn bg-white text-navy-950 hover:bg-sky-100">
              <i class="fas fa-phone text-xs"></i>Call 07534 490921
            </a>
            <a href="#contact" class="btn border border-white/25 text-white hover:bg-white/10">Message us</a>
          </div>
        </div>

        <ol class="relative space-y-px">
          <li
            v-for="(step, i) in steps"
            :key="step.title"
            class="group relative flex gap-6 border-t border-white/10 py-7 first:border-t-0 first:pt-0"
          >
            <span class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/10 text-base font-extrabold text-sky-300 ring-1 ring-white/10 transition group-hover:bg-sky-300 group-hover:text-navy-950">
              {{ String(i + 1).padStart(2, '0') }}
            </span>
            <div>
              <h3 class="text-lg font-bold text-white">{{ step.title }}</h3>
              <p class="mt-2 max-w-xl text-sm leading-7 text-sky-200/75">{{ step.description }}</p>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script setup>
const steps = [
  {
    title: 'Tell us about the job',
    description: 'Call, email or send a photo on Instagram or Facebook. A couple of pictures is usually all we need to price it.'
  },
  {
    title: 'Get a free, fixed quote',
    description: 'A clear price with no obligation and no surprise extras added on the day.'
  },
  {
    title: 'We turn up and clean',
    description: 'Fully insured, with the right method for each surface, whether that\'s pure water, low pressure or rotary cleaning.'
  },
  {
    title: 'You check it before we go',
    description: 'We pack down, leave the site tidy, and only finish once you are happy with the result.'
  }
]
</script>
